// Two-step password reset flow:
//   /#/forgot-password — enter email → email gets sent (always success message)
//   /#/reset-password?token=… — clicked from email → enter new password
import { ApiError, api } from '../api/client';
export function renderForgotPassword(root, goToLogin) {
    root.innerHTML = `
    <div class="auth-screen">
      <h1 class="brand">Plunder</h1>
      <h2 class="auth-title">Forgot your password?</h2>
      <p class="auth-blurb">Enter your email. We'll send you a link to set a new password. The link is good for one hour.</p>
      <form id="forgot-form" class="auth-form">
        <label>Email
          <input id="forgot-email" type="email" autocomplete="email" required maxlength="254" />
        </label>
        <button type="submit" class="btn btn--primary" id="forgot-submit">Send reset link</button>
      </form>
      <div class="auth-status" id="forgot-status"></div>
      <div class="auth-links">
        <a href="#" id="back-to-login">← Back to sign in</a>
      </div>
    </div>`;
    root.querySelector('#back-to-login')?.addEventListener('click', (e) => {
        e.preventDefault();
        goToLogin();
    });
    root.querySelector('#forgot-form')?.addEventListener('submit', async (e) => {
        e.preventDefault();
        const emailInput = root.querySelector('#forgot-email');
        const submit = root.querySelector('#forgot-submit');
        const status = root.querySelector('#forgot-status');
        const email = emailInput.value.trim();
        if (!email)
            return;
        submit.disabled = true;
        submit.textContent = 'Sending…';
        try {
            await api.passwordResetRequest(email);
            status.innerHTML = `
        <div class="auth-success">
          ✓ If <strong>${escape(email)}</strong> matches a registered account, a reset link is on the way.
          Check your inbox (and spam folder). The link expires in 1 hour.
        </div>`;
            submit.style.display = 'none';
            emailInput.disabled = true;
        }
        catch (err) {
            const msg = err instanceof ApiError ? err.message : err.message;
            status.innerHTML = `<div class="auth-error">${escape(msg)}</div>`;
            submit.disabled = false;
            submit.textContent = 'Send reset link';
        }
    });
}
export function renderResetPassword(root, token, goToLogin) {
    root.innerHTML = `
    <div class="auth-screen">
      <h1 class="brand">Plunder</h1>
      <h2 class="auth-title">Set a new password</h2>
      <p class="auth-blurb">Pick a strong password — at least 8 characters and not one of the millions found in known data breaches.</p>
      <form id="reset-form" class="auth-form">
        <label>New password
          <input id="reset-password" type="password" autocomplete="new-password" required minlength="8" maxlength="256" />
        </label>
        <label>Confirm
          <input id="reset-password-2" type="password" autocomplete="new-password" required minlength="8" maxlength="256" />
        </label>
        <button type="submit" class="btn btn--primary" id="reset-submit">Set password</button>
      </form>
      <div class="auth-status" id="reset-status"></div>
      <div class="auth-links">
        <a href="#" id="back-to-login">← Back to sign in</a>
      </div>
    </div>`;
    root.querySelector('#back-to-login')?.addEventListener('click', (e) => {
        e.preventDefault();
        goToLogin();
    });
    root.querySelector('#reset-form')?.addEventListener('submit', async (e) => {
        e.preventDefault();
        const pw1 = root.querySelector('#reset-password').value;
        const pw2 = root.querySelector('#reset-password-2').value;
        const submit = root.querySelector('#reset-submit');
        const status = root.querySelector('#reset-status');
        if (pw1 !== pw2) {
            status.innerHTML = `<div class="auth-error">Passwords don't match.</div>`;
            return;
        }
        submit.disabled = true;
        submit.textContent = 'Resetting…';
        try {
            await api.passwordResetConfirm(token, pw1);
            status.innerHTML = `
        <div class="auth-success">
          ✓ Password updated. All other sessions have been signed out for safety.
          <button class="btn btn--primary" id="go-login">Sign in</button>
        </div>`;
            submit.style.display = 'none';
            root.querySelector('#go-login')?.addEventListener('click', goToLogin);
        }
        catch (err) {
            const msg = err instanceof ApiError ? err.message : err.message;
            status.innerHTML = `<div class="auth-error">${escape(msg)}</div>`;
            submit.disabled = false;
            submit.textContent = 'Set password';
        }
    });
}
export function renderVerifyEmail(root, token, goToLobby, goToLogin) {
    root.innerHTML = `
    <div class="auth-screen">
      <h1 class="brand">Plunder</h1>
      <h2 class="auth-title">Verifying your email…</h2>
      <div class="auth-status" id="verify-status">Just a moment.</div>
    </div>`;
    api.verifyEmail(token).then((res) => {
        root.querySelector('#verify-status').innerHTML = `
      <div class="auth-success">
        ✓ Welcome aboard, Captain <strong>${escape(res.display_name)}</strong>. Your email is confirmed.
        <button class="btn btn--primary" id="go-lobby">To the lobby ⚓</button>
      </div>`;
        root.querySelector('#go-lobby')?.addEventListener('click', goToLobby);
    }).catch((err) => {
        const msg = err instanceof ApiError ? err.message : err.message;
        root.querySelector('#verify-status').innerHTML = `
      <div class="auth-error">${escape(msg)}</div>
      <button class="btn" id="go-login">Sign in</button>`;
        root.querySelector('#go-login')?.addEventListener('click', goToLogin);
    });
}
function escape(s) {
    return s.replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
}
